import React from "react";
import { memo } from "react";

// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import useAuth from "hooks/useAuth";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { user } = useAuth();

  const itemsWithPermissions = menuItem.items
    .map((item) => {
      if (!user || !item.children) {
        return item;
      }

      const filteredChildren = item.children.filter((child) => {
        if (child.id === "default" && user.canViewDashboard === false) {
          return false;
        }

        if (child.id === "analytics" && user.canViewFinance === false) {
          return false;
        }

        if (child.id === "acc-deposit" && user.canViewDeposit === false) {
          return false;
        }

        if (child.id === "acc-withdraw" && user.canViewWithdraw === false) {
          return false;
        }

        if (child.id === "customers" && user.canViewCustomer === false) {
          return false;
        }

        if (child.id === "admins" && user.canViewAdmin === false) {
          return false;
        }

        if (child.id === "customers" && user.canViewCustomer === false) {
          return false;
        }

        if (child.id === "creditcode" && user.canViewCreditCode === false) {
          return false;
        }

        if (child.id === "promotion" && user.canViewPromotion === false) {
          return false;
        }

        if (child.id === "campaign" && user.canViewCampaign === false) {
          return false;
        }

        if (child.id === "ranking" && user.canViewRanking === false) {
          return false;
        }

        if (child.id === "wheeling" && user.canViewWheelPrize === false) {
          return false;
        }

        if (child.id === "friendinvite" && user.canViewFriendInvite === false) {
          return false;
        }

        if (child.id === "cashback" && user.canViewCashback === false) {
          return false;
        }

        if (child.id === "turn-setting" && user.canViewTurnSetting === false) {
          return false;
        }

        if (child.id === "web-setting" && user.canViewWebSetting === false) {
          return false;
        }

        if (
          child.id === "banner-setting" &&
          user.canViewBannerSetting === false
        ) {
          return false;
        }

        if (
          child.id === "popup-setting" &&
          user.canViewPopupSetting === false
        ) {
          return false;
        }

        if (child.id === "book-bank" && user.canViewBankSetting === false) {
          return false;
        }

        if (
          child.id === "payment-setting" &&
          user.canViewPaymentSetting === false
        ) {
          return false;
        }

        if (
          child.id === "acc-deposit-summary" &&
          user.canViewDepositSummary === false
        ) {
          return false;
        }

        if (
          child.id === "acc-withdraw-summary" &&
          user.canViewWithdrawSummary === false
        ) {
          return false;
        }

        return true;
      });

      return { ...item, children: filteredChildren };
    })
    .filter((item) => !item.children || item.children.length > 0);

  const navItems = itemsWithPermissions.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default memo(MenuList);
